import fs from 'node:fs'
import { scopeDir } from './scope-dir.js'

export function deleteSnapshot(cwd: string, scope: string): void {
  fs.rmSync(scopeDir(cwd, scope), { recursive: true, force: true })
}
